import { render, staticRenderFns } from "./base-box.vue?vue&type=template&id=923e5a9e"
import script from "./base-box.vue?vue&type=script&lang=js"
export * from "./base-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports